/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { batch } from 'react-redux';

import { pageTransfer } from '../../../utils/history';
import { workflow } from '../../../config/routeconfig';
import { selectWorkflow } from '../../../selectors';
import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

export const {
  markCurrentStepAsCompleted,
  updateWorkflowSteps,
  resetCurrentStep,
  updateNextStep,
  appendToActiveStepLinks,
  divertProgress,
  globalReset,
  idVerificationMaxed,
} = createActions(
  actionTypes.MARK_CURRENT_STEP_AS_COMPLETED,
  actionTypes.UPDATE_WORKFLOW_STEPS,
  actionTypes.RESET_CURRENT_STEP,
  actionTypes.UPDATE_NEXT_STEP,
  actionTypes.APPEND_TO_ACTIVE_STEP_LINKS,
  actionTypes.DIVERT_PROGRESS,
  actionTypes.GLOBAL_RESET,
  actionTypes.ID_VERIFICATION_MAXED,
  getActionOptions(ACTION_PREFIX),
);

const proceedToNextStep = (
  dispatch,
  activeStepIndex,
  steps,
  nextStepLinks,
  activeMainStepIndex,
) => {
  const { nextStepIndex, nextMainStepIndex, nextSteps, nextStep } = workflow.processNextStep(
    activeStepIndex,
    steps,
    nextStepLinks,
    activeMainStepIndex,
  );

  dispatch(
    updateNextStep({
      activeStepIndex: nextStepIndex,
      activeMainStepIndex: nextMainStepIndex,
      steps: nextSteps,
    }),
  );

  if (nextStep.component) pageTransfer.push(nextStep.path[0]);
};

export const RouteToAlert = (alertRouteConfig) => () => {
  pageTransfer.push(alertRouteConfig.path);
};

export const gotoNextStep = () => (dispatch, getState) => {
  const state = getState();
  const { activeStepIndex, steps, nextStepLinks, activeMainStepIndex } = selectWorkflow(state);

  proceedToNextStep(dispatch, activeStepIndex, steps, nextStepLinks, activeMainStepIndex);
};

export const restartWorkflow = (location) => (dispatch, getState) => {
  const state = getState();
  const { steps } = state.workflow;
  if (location && location.search) {
    pageTransfer.push({ pathname: steps[0].path[0], search: location.search });
  } else {
    pageTransfer.push(steps[0].path[0]);
    dispatch(globalReset());
  }
};

export const markCurrentStepAsCompletedAndGoToNextStep =
  (nextStepLinks) => (dispatch, getState) => {
    const state = getState();
    const { activeStepIndex, steps, activeMainStepIndex } = selectWorkflow(state);
    batch(() => {
      dispatch(markCurrentStepAsCompleted({ nextStepLinks }));
      proceedToNextStep(dispatch, activeStepIndex, steps, nextStepLinks, activeMainStepIndex);
    });
  };

export const switchToTrusteeWorkflow = () => (dispatch) => {
  dispatch(updateWorkflowSteps(workflow.getTrusteeWorkflowSteps()));
};
